export const TRANSITION_TIMEOUT = 500;
